<template>
<div>
  <div v-if="getCount > 0">
    <div class="table__wrapper">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>NAME</th>
            <th>ROLE</th>
            <th>REFERRED</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(referral, index) in referrals" :key="index"
            v-on:click="onReferralClicked(referral)" class="clickable">
            <td class="is-4">{{ name(referral) }}</td>
            <td>{{ referral.userRole || 'N/A' }}</td>
            <td>{{ created(referral) }}</td>
            <td class="status" :class="status(referral)">
              {{ status(referral) }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <empty-state v-else title="No Referrals" icon="empty-state-eyes">
    <template slot="content">To refer somebody either 1) Go to a <router-link to="/jobs">job</router-link> and click Refer Somebody OR 2) Go to <router-link to="/jobseekers">jobseeker's</router-link> <br/>profile and click Refer For Job. Let us know if you need support in Telegram.</template>
  </empty-state>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import Heading from '@/components/general/heading'
import moment from 'moment'
import EmptyState from '@/components/general/empty-state'

export default {
  name: 'ReferralsList',
  components: {
    Columns, Column, Heading, EmptyState
  },
  props: {
    referrals: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('referrals', [
      'referralStatus'
    ]),
    getCount () {
      return this.referrals && this.referrals.length
    }
  },
  methods: {
    onReferralClicked (item) {
      this.$emit('select', item)
    },
    name (referral) {
      if (referral.email !== null) {
        return referral.email
      }
      return `${referral.userFirstName} ${referral.userLastName}`
    },
    created (referral) {
      return moment(referral.createdAt).format('DD MMM YY')
    },
    status (referral) {
      return this.referralStatus(referral)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

h6.heading {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
}

.columns {
  margin: 0;
  padding: 0;
  .column {
    padding: 0 1rem;
  }
}

.columns:not(:last-child) {
  border-bottom: solid 1px #ddd;
}

.tbody {
  font-size: 0.875rem;
  background-color: white;
  border: solid 1px #ddd;
  border-radius: 4px;
  .columns {
    height: 3rem;
    align-items: center;
    cursor: pointer;
    &:hover {
      background-color: $hover-background;
      border-radius: 4px;
    }
  }
}

.status {
  font-weight: bold;
  letter-spacing: 2px;
  color: $primary;
  text-transform: uppercase;

  &.pending {
    color: #cccccc;
  }

  &.applied {
    color: $black;
  }

  &.rejected {
    color: $red;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/referrals/referrals-list.vue